var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62 11.7475C8.06 14.5775 10.38 16.8875 13.21 18.3375L15.41 16.1375C15.68 15.8675 16.08 15.7775 16.43 15.8975C17.55 16.2675 18.76 16.4675 20 16.4675C20.55 16.4675 21 16.9175 21 17.4675V20.9575C21 21.5075 20.55 21.9575 20 21.9575C10.61 21.9575 3 14.3475 3 4.95752C3 4.40752 3.45 3.95752 4 3.95752H7.5C8.05 3.95752 8.5 4.40752 8.5 4.95752C8.5 6.20752 8.7 7.40752 9.07 8.52752C9.18 8.87752 9.1 9.26752 8.82 9.54752L6.62 11.7475Z",
    fill: "#C2D1D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_826_17202",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62 11.7475C8.06 14.5775 10.38 16.8875 13.21 18.3375L15.41 16.1375C15.68 15.8675 16.08 15.7775 16.43 15.8975C17.55 16.2675 18.76 16.4675 20 16.4675C20.55 16.4675 21 16.9175 21 17.4675V20.9575C21 21.5075 20.55 21.9575 20 21.9575C10.61 21.9575 3 14.3475 3 4.95752C3 4.40752 3.45 3.95752 4 3.95752H7.5C8.05 3.95752 8.5 4.40752 8.5 4.95752C8.5 6.20752 8.7 7.40752 9.07 8.52752C9.18 8.87752 9.1 9.26752 8.82 9.54752L6.62 11.7475Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_826_17202)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.95752,
    width: 24,
    height: 24,
    fill: "#424B5A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.b0a04e1ebd7d5d33b8aebb22f0142bb4.svg";
export { ForwardRef as ReactComponent };